export enum SideFilterMode {
  OVERLAY = 'overlay',
  PUSH = 'push',
}
